<template>
  <v-container class="pt-2 px-0" fluid>
    <v-layout wrap>
      <v-flex xs12>
        <v-data-table
          :headers="virtualSpacecraftHeaders"
          :items="myRun.config.heliospheric_model.VirtualSpacecraft"
          :pagination.sync="virtualSpacecraftPagination"
          must-sort
        >
          <template slot="items" slot-scope="props">
            <td
              :style="{cursor: 'pointer'}"
              @click="editVirtualSpacecraft(props.item)"
              class="text-no-wrap"
            >{{ props.item.relative_to }}</td>
            <td :style="{cursor: 'pointer'}" @click="editVirtualSpacecraft(props.item)">{{ props.item.start }}</td>
            <td :style="{cursor: 'pointer'}" @click="editVirtualSpacecraft(props.item)">{{ props.item.shift_r }}</td>
            <td :style="{cursor: 'pointer'}" @click="editVirtualSpacecraft(props.item)">{{ props.item.shift_lon }}</td>
            <td :style="{cursor: 'pointer'}" @click="editVirtualSpacecraft(props.item)">{{ props.item.shift_lat }}</td>
            <td class="text-xs-right">
              <v-icon @click="editVirtualSpacecraft(props.item)" class="mr-2" small>edit</v-icon>
              <v-icon @click="deleteVirtualSpacecraft(props.item)" small>delete</v-icon>
            </td>
          </template>
          <template slot="actions-append">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn @click="addVirtualSpacecraft()" fab icon v-on="on">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Add virtual spacecraft</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="600px" v-model="dialogVirtualSpacecraft">
          <v-card>
            <v-card-title class="px-3">
              <span class="headline">Virtual spacecraft</span>
            </v-card-title>
            <v-card-text>
              <v-container class="pa-0" grid-list-md>
                <v-layout wrap>
                  <v-flex class="px-2" md6 xs12>
                    <v-select
                      :items="relativeToOptions"
                      label="Relative to"
                      v-model="virtualSpacecraftConfig.relative_to"
                    ></v-select>
                  </v-flex>
                  <v-flex class="px-2" md6 xs12>
                    <v-select :items="startOptions" label="Start" v-model="virtualSpacecraftConfig.start"></v-select>
                  </v-flex>
                  <v-flex class="px-2" md4 xs12>
                    <v-text-field
                      hint="Radial shift in solar radii"
                      label="Radial shift"
                      suffix="Rs"
                      type="number"
                      v-model="virtualSpacecraftConfig.shift_r"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="px-2" md4 xs12>
                    <v-text-field
                      hint="Longitudinal shift in degrees"
                      label="Longitudinal shift"
                      suffix="deg"
                      type="number"
                      v-model="virtualSpacecraftConfig.shift_lon"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="px-2" md4 xs12>
                    <v-text-field
                      hint="Latitudinal shift in degrees"
                      label="Latitudinal shift"
                      suffix="deg"
                      type="number"
                      v-model="virtualSpacecraftConfig.shift_lat"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogVirtualSpacecraft=false" flat>Cancel</v-btn>
              <v-btn @click="saveVirtualSpacecraft()" color="info">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  data() {
    return {
      virtualSpacecraftHeaders: [
        { text: 'Relative to', align: 'left', sortable: true, value: 'relative_to' },
        { text: 'Start from', align: 'left', sortable: true, value: 'start' },
        { text: 'Radial shift', align: 'left', sortable: true, value: 'shift_r' },
        { text: 'Longitudinal shift', align: 'left', sortable: true, value: 'shift_lon' },
        { text: 'Latitudinal shift', align: 'left', sortable: true, value: 'shift_lat' },
        { text: 'Actions', align: 'right', sortable: false, value: 'name' },
      ],
      startOptions: ['relaxation', 'forecast'],
      relativeToOptions: ['Earth', 'Mercury', 'Venus', 'Mars', 'STA', 'STB'],
      dialogVirtualSpacecraft: false,
      virtualSpacecraftConfigDefault: {
        relative_to: 'Earth',
        start: 'relaxation',
        shift_r: 0.0,
        shift_lon: 0.0,
        shift_lat: 0.0,
      },
      virtualSpacecraftIndex: null,
      virtualSpacecraftConfig: {},
      virtualSpacecraftPagination: {
        rowsPerPage: -1,
        sortBy: 'relative_to',
        descending: false,
      },
    };
  },
  methods: {
    addVirtualSpacecraft() {
      this.virtualSpacecraftIndex = null;
      this.virtualSpacecraftConfig = Object.assign({}, this.virtualSpacecraftConfigDefault);
      this.dialogVirtualSpacecraft = true;
    },
    editVirtualSpacecraft(virtualSpacecraft) {
      this.virtualSpacecraftIndex = this.myRun.config.heliospheric_model.VirtualSpacecraft.indexOf(virtualSpacecraft);
      this.virtualSpacecraftConfig = Object.assign(
        {},
        this.myRun.config.heliospheric_model.VirtualSpacecraft[this.virtualSpacecraftIndex]
      );
      this.dialogVirtualSpacecraft = true;
    },
    saveVirtualSpacecraft() {
      if (!('VirtualSpacecraft' in this.myRun.config.heliospheric_model)) {
        this.myRun.config.heliospheric_model.VirtualSpacecraft = [];
      }
      if (this.virtualSpacecraftIndex == null) {
        this.myRun.config.heliospheric_model.VirtualSpacecraft.push(this.virtualSpacecraftConfig);
      } else {
        this.$set(
          this.myRun.config.heliospheric_model.VirtualSpacecraft,
          this.virtualSpacecraftIndex,
          Object.assign({}, this.virtualSpacecraftConfig)
        );
      }
      this.dialogVirtualSpacecraft = false;
    },
    deleteVirtualSpacecraft(virtualSpacecraft) {
      const index = this.myRun.config.heliospheric_model.VirtualSpacecraft.indexOf(virtualSpacecraft);
      this.myRun.config.heliospheric_model.VirtualSpacecraft.splice(index, 1);
    },
  },
};
</script>
